export default "__VITE_ASSET__$xQt0e3w__"